<div class="auth-wrapper">
  <div class="auth-card">
    <h2 class="title">Choose your account type</h2>
    <p class="subtitle">
      Select the option that best describes you
    </p>

    <div class="option-grid">
      <div class="option-card" routerLink="/individual">
        <div class="icon">
         <img src="assets/img/indivisual.png" alt="">
        </div>
        <h3>Individual</h3>
        <p>For independent event organizers and creators</p>
      </div>

      <div class="option-card" routerLink="/organiser">
        <div class="icon">
          <img src="assets/img/organisation.png" alt="">
        </div>
        <h3>Organization</h3>
        <p>For companies, agencies, and institutions</p>
      </div>
    </div>

   
  </div>
   <div class="step-dots">
      <span class="dot active"></span>
      <span class="dot"></span>
      <span class="dot"></span>
       <span class="dot"></span>
      <span class="dot"></span>
       <span class="dot"></span>
      <span class="dot"></span>
    </div>

</div>
